// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
//= require confirmation_banner/_namespace
//= require_tree .
// MAGIC_DESPROCKET_START
require('sprocket-compat?this!javascripts/confirmation_banner/_namespace.coffee')
require('javascripts/confirmation_banner/templates/below_nav_view_JST.wjs.js')
require('javascripts/confirmation_banner/templates/overlay_view_JST.wjs.js')
require('sprocket-compat?this!javascripts/confirmation_banner/views/below_nav_view.coffee')
require('sprocket-compat?this!javascripts/confirmation_banner/views/overlay_view.coffee')
// MAGIC_DESPROCKET_END
